import { ROUTES } from "./siteConfig";

export const servicePages = {
  websitesUnternehmen: {
    path: "/websites-fuer-unternehmen",
    title: "Websites für Unternehmen",
    metaTitle: "Websites für Unternehmen | Website als Teil Ihrer Marketing-Strategie",
    metaDescription:
      "Websites für Unternehmen in Österreich: Die Website als Fundament Ihrer digitalen Marketing-Strategie. Professionell, suchmaschinenoptimiert und mit klarem Bezug zu Social Media und Online-Präsenz.",
    h1: "Websites für Unternehmen – Das Fundament Ihrer digitalen Marketing-Strategie",
    intro:
      "Eine professionelle Website ist die Basis Ihrer digitalen Vermarktung: Hier landen Besucher aus Suchmaschinen und Social Media, hier werden Sie als Unternehmen sichtbar. Wir entwickeln Websites, die zu Ihrer Marketing-Strategie passen und Besucher in Kunden verwandeln.",
    sections: [
      {
        title: "Website und digitale Vermarktung",
        content:
          "Die Website ist das zentrale Schaufenster Ihrer Online-Präsenz. Sie unterstützt Ihre Social-Media-Aktivitäten, liefert Inhalte für Suchmaschinen und schafft Vertrauen. Wir verbinden Webdesign mit Ihren Marketing-Zielen – klar, schnell und suchmaschinenoptimiert.",
      },
      {
        title: "Für wen eignet sich eine Unternehmenswebsite?",
        content:
          "Für KMU, Handwerker, Ärzte, Restaurants und Dienstleister in Österreich, die ihre digitale Sichtbarkeit ausbauen möchten. Ob als Ergänzung zur Social-Media-Betreuung oder als erster Schritt: Die Website ist der Anker Ihrer digitalen Präsenz.",
      },
    ],
    faqs: [
      {
        q: "Wie hängt die Website mit Social Media Marketing zusammen?",
        a: "Die Website ist der Ort, an dem Sie Besucher aus Social Media und Suchmaschinen hinführen. Dort finden sie alle Informationen, Kontaktmöglichkeiten und Vertrauenssignale. Ohne eine klare Website fehlt Ihrer Social-Media-Strategie die Basis.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
    ],
  },
  webdesign: {
    path: "/webdesign",
    title: "Webdesign",
    metaTitle: "Webdesign Agentur | Professionelle Websites für Unternehmen",
    metaDescription:
      "Professionelles Webdesign für Unternehmen in Österreich: Moderne Websites, klare Struktur, Suchmaschinen-Optimierung. Die Website als Fundament Ihrer digitalen Marketing-Strategie.",
    h1: "Webdesign – Professionelle Websites für Ihr Unternehmen",
    intro:
      "Eine professionelle Website ist die Visitenkarte Ihres Unternehmens und das Fundament Ihrer digitalen Marketing-Strategie. Wir entwickeln Websites, die Vertrauen schaffen, Besucher führen und in Suchmaschinen gefunden werden – und die sich nahtlos in Ihre digitale Vermarktung und Social-Media-Präsenz einfügen.",
    sections: [
      {
        title: "Was umfasst unser Webdesign?",
        content:
          "Von der Konzeption über das Design bis zur technischen Umsetzung: Wir erstellen responsive Websites mit klarer Struktur, guter Ladegeschwindigkeit und Suchmaschinen-Optimierung (SEO). Ob One-Pager, Mehrseiten-Website oder mit Blog – wir passen die Lösung an Ihre Ziele an. Die Website wird so zum zentralen Baustein Ihrer Online-Präsenz.",
      },
      {
        title: "Webdesign im Kontext Ihrer Marketing-Strategie",
        content:
          "Websites und Branding sind bei uns Werkzeuge innerhalb einer größeren Strategie: Digitale Vermarktung, Social Media und Sichtbarkeit. Unser Webdesign richtet sich an KMU und Unternehmen in Österreich, die mit einer professionellen Website und klarer digitaler Präsenz Kunden gewinnen möchten.",
      },
    ],
    faqs: [
      {
        q: "Wie lange dauert die Erstellung einer Website?",
        a: "Je nach Umfang planen wir mit wenigen Wochen bis zu mehreren Monaten. In einem ersten Gespräch klären wir den Zeitrahmen und die Meilensteine.",
      },
      {
        q: "Was kostet eine professionelle Website?",
        a: "Die Kosten hängen von Seitenanzahl, Designaufwand und Funktionalität ab. Eine Übersicht finden Sie auf unserer Seite Webdesign Kosten Österreich.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Websites für Unternehmen", path: ROUTES.websitesUnternehmen },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
      { label: "Website Relaunch", path: ROUTES.serviceRelaunch },
    ],
  },
  branding: {
    path: "/branding",
    title: "Branding",
    metaTitle: "Branding Agentur | Markenentwicklung & Markenstrategie",
    metaDescription:
      "Branding und Markenentwicklung für Unternehmen in Österreich: Starke Marken, klare Positionierung, konsistente Kommunikation.",
    h1: "Branding – Starke Marken für Ihr Unternehmen",
    intro:
      "Eine starke Marke unterscheidet Sie von der Konkurrenz und schafft Vertrauen. Wir entwickeln Markenstrategien, Logos und visuelle Identitäten, die zu Ihrem Unternehmen passen und langfristig wirken.",
    sections: [
      {
        title: "Was bedeutet Branding für uns?",
        content:
          "Branding umfasst die strategische und visuelle Entwicklung Ihrer Marke: Positionierung, Name, Logo, Farben, Typografie und Anwendungen (z. B. Website, Geschäftspapiere, Social Media). Alles aus einer Hand für ein stimmiges Erscheinungsbild.",
      },
    ],
    faqs: [
      {
        q: "Was ist der Unterschied zwischen Branding und Corporate Design?",
        a: "Branding ist die übergeordnete Markenstrategie und -identität; Corporate Design ist die konkrete visuelle Umsetzung (Logo, Farben, Anwendungen). Beides gehört bei uns zusammen.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Markenpräsenz", path: ROUTES.digitaleMarkenpraesenz },
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Branding Kosten Österreich", path: ROUTES.costBranding },
      { label: "Corporate Design", path: ROUTES.serviceCorporateDesign },
    ],
  },
  corporateDesign: {
    path: "/corporate-design",
    title: "Corporate Design",
    metaTitle: "Corporate Design Agentur | Logo, Farben, einheitliches Erscheinungsbild",
    metaDescription:
      "Corporate Design für Unternehmen: Logo, Farben, Typografie und einheitliche Anwendungen. Professionelles Erscheinungsbild für Print und Digital.",
    h1: "Corporate Design – Einheitliches Erscheinungsbild für Ihre Marke",
    intro:
      "Corporate Design sorgt dafür, dass Ihre Marke überall wiedererkannt wird – auf der Website, in Broschüren, auf Social Media und in der Werbung. Wir entwickeln Leitlinien und setzen sie konsistent um.",
    sections: [
      {
        title: "Was gehört zum Corporate Design?",
        content:
          "Logo, Farbpalette, Schriftarten, Bildsprache und Anwendungsbeispiele (Visitenkarte, Briefbogen, Website, Social Media). Wir erstellen ein CD-Handbuch, an dem Sie und weitere Dienstleister sich orientieren können.",
      },
    ],
    faqs: [
      {
        q: "Brauche ich ein Corporate Design, wenn ich nur eine Website will?",
        a: "Für eine Website reicht oft ein klares Logo und eine abgestimmte Farb- und Schriftwahl. Ein vollständiges Corporate Design lohnt sich, wenn Sie auch in Print und Werbung einheitlich auftreten möchten.",
      },
    ],
    relatedLinks: [
      { label: "Branding", path: ROUTES.serviceBranding },
      { label: "Digitale Markenpräsenz", path: ROUTES.digitaleMarkenpraesenz },
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
    ],
  },
  digitaleStrategie: {
    path: "/digitale-strategie",
    title: "Digitale Strategie",
    metaTitle: "Digitale Strategie | Beratung für Web & Marketing",
    metaDescription:
      "Digitale Strategie und Beratung: Ziele, Zielgruppen, Kanäle und Maßnahmen. Wir entwickeln mit Ihnen einen Plan für Ihre digitale Präsenz.",
    h1: "Digitale Strategie – Der Plan für Ihre digitale Präsenz",
    intro:
      "Bevor wir designen und umsetzen, klären wir: Wo wollen Sie hin? Wen wollen Sie erreichen? Welche Kanäle und Inhalte passen dazu? Unsere digitale Strategie bringt Ziele und Maßnahmen in Einklang.",
    sections: [
      {
        title: "Was umfasst die digitale Strategie?",
        content:
          "Analyse von Zielgruppe, Wettbewerb und Ausgangslage; Definition von Zielen und Kennzahlen; Empfehlungen zu Website, Social Media, Content und Werbung. Am Ende steht ein umsetzbarer Fahrplan.",
      },
    ],
    faqs: [
      {
        q: "Für wen eignet sich eine Strategie-Beratung?",
        a: "Besonders für Unternehmen, die ihre digitale Präsenz ausbauen oder neu ausrichten möchten und eine klare Linie brauchen – bevor viel umgesetzt wird.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Online-Marketing für Unternehmen", path: ROUTES.onlineMarketingUnternehmen },
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Website Relaunch", path: ROUTES.serviceRelaunch },
    ],
  },
  websiteRelaunch: {
    path: "/website-relaunch",
    title: "Website Relaunch",
    metaTitle: "Website Relaunch | Alte Website modernisieren",
    metaDescription:
      "Website Relaunch: Alte Website modernisieren, Design und Technik erneuern. Professionelle Relaunch-Projekte für Unternehmen in Österreich.",
    h1: "Website Relaunch – Ihre Website auf den neuesten Stand bringen",
    intro:
      "Ihre Website ist veraltet, langsam oder nicht mehr passend? Ein Relaunch bringt Design, Technik und Inhalte auf ein neues Niveau – ohne Ihre bewährten Stärken zu ignorieren.",
    sections: [
      {
        title: "Wann lohnt sich ein Website Relaunch?",
        content:
          "Wenn die Website technisch veraltet ist, nicht mobil optimiert, schwer zu pflegen oder optisch nicht mehr zu Ihrer Marke passt. Wir analysieren die bestehende Seite und schlagen einen sinnvollen Umfang vor – vom Redesign bis zum kompletten Neubau.",
      },
    ],
    faqs: [
      {
        q: "Verliere ich meine Suchmaschinen-Rankings beim Relaunch?",
        a: "Bei einem fachgerechten Relaunch werden URLs und wichtige Inhalte so migriert, dass Rankings erhalten bleiben können. Wir achten auf Redirects und SEO.",
      },
    ],
    relatedLinks: [
      { label: "Websites für Unternehmen", path: ROUTES.websitesUnternehmen },
      { label: "Webdesign", path: ROUTES.serviceWebdesign },
      { label: "Webdesign Kosten Österreich", path: ROUTES.costWebdesign },
    ],
  },
};
